import React from 'react';
import moment from 'moment';
import {
  InfoBoxContainer, InfoItem, InfortuniCardInfoStyles, TitleActionBox,
} from './InfortuniCardInfo.styles';
import { ModificaDatiButton } from '../common/Redesign.styles';
import editIcon from '../../../../assets/redesign_icons/edit-icon.svg';

function InfortuniCardInfo({ insuranceRequest, modificaDati, customer }) {
  return (
    <InfortuniCardInfoStyles>
      <TitleActionBox>
        <h4>
          Informazioni
          {' '}
          <b>infortuni</b>
        </h4>
        <ModificaDatiButton onClick={modificaDati}>
          <p>Modifica Dati</p>
          <img src={editIcon} alt="Modifica Dati" />
        </ModificaDatiButton>
      </TitleActionBox>
      <InfoBoxContainer>
        <InfoItem>
          <h4>Contraente:</h4>
          <p>
            {customer.gender !== 'G' ? `${customer.name} ${customer.surname}` : customer.business_name}
          </p>
        </InfoItem>
        <InfoItem>
          <h4>Telefono:</h4>
          <p>{customer.phone}</p>
        </InfoItem>
        <InfoItem>
          <h4>Residenza:</h4>
          <p>{`${customer.province.name}, ${customer.province.car_plate_symbol}`}</p>
        </InfoItem>
        <InfoItem>
          <h4>Inizio Copertura:</h4>
          <p>{moment(insuranceRequest.policy_effective_date).format('DD-MM-YYYY')}</p>
        </InfoItem>
      </InfoBoxContainer>
    </InfortuniCardInfoStyles>
  );
}

export default InfortuniCardInfo;
